var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('div',{staticStyle:{"padding":"10px"}},[_c('center',[_vm._v("Please wait while we take you to the "+_vm._s(_vm.direction)+" "+_vm._s(_vm.type))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }